import {
	Modal,
	ModalDialog,
	ModalClose,
	Typography,
} from "@mui/joy";
import React from "react";

import { CodeEditor } from "../../../shared/CodeEditor";

import { getCodeModalWidth } from "./codeModalSizing";

type TViewCodeModalProps = {
	open: boolean;
	onClose: () => void;
	code: string;
	language: string;
};

const ViewCodeModal: React.FC<TViewCodeModalProps> = ({
	open,
	onClose,
	code,
	language,
}) => {
	const modalWidth = React.useMemo(
		() => getCodeModalWidth(code),
		[code]
	);

	return (
		<Modal
			open={open}
			onClose={onClose}
			sx={{ zIndex: 1605 }}
		>
			<ModalDialog
				sx={{
					width: modalWidth,
					maxWidth: "calc(100vw - 48px)",
					height: "85vh",
					zIndex: 1606,
				}}
			>
				<ModalClose />
				<Typography
					level="h4"
					sx={{ mb: 2 }}
				>
					Code - {language}
				</Typography>

				<div className="code-editor-wrapper">
					<CodeEditor
						value={code}
						readOnly={true}
						showLineNumber={true}
						minHeight="400px"
						maxHeight="70vh"
					/>
				</div>
			</ModalDialog>
		</Modal>
	);
};

export default ViewCodeModal;
